<script context="module">
    import newUniqueId from 'locally-unique-id-generator'
    import Select from 'svelte-select';

</script>


<script lang="ts">

    import {getValue} from "felte";
    import {myStore} from "../../stores";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let disabled = false;
    export let items = [];

    export let value;
    export let placeholder;
    export let formValue;

    export let selection;

    export let formField;

    export let error = false;

    let id = newUniqueId();

    function handleSelect(event) {
        // event.detail will contain the selected value
         //   event.stopPropagation();
            console.log("clicked");
        dispatch('select', {
            value: selection
        });

        if(formField){
            $myStore.setData(formField, (val) => selection.value);
        }

        //     open = true;
    }


</script>
<!--<svelte:window on:keypress={handleKey}/>-->
<label for="{id}"  class="single-select" >
<Select id="{id}"


        hasError={error}
        {items} {placeholder}
        isDisabled={disabled}
        bind:value={selection}
        on:select={handleSelect}
        --borderRadius="9px"
        --listBorderRadius="9px"
        --inputColor="#054055"
        --indicatorColor="#054055"
        --itemHoverBG="#E7E7E7"
        --itemIsActiveBG="#E7E7E7"
        --itemIsActiveColor="#054055"
        --borderFocusColor="#3384B8"
        isSearchable={false}  />
</label>

<style lang="scss">



    label {
      width:100%;
     // display:flex;
     // align-items:center;
     // line-height: normal;

      color:$primary-color;
      background-color: $white;
      //padding: 5px 15px;
      //font-family: sans-serif, Arial;
      font-size: 16px;
      //border: 2px solid transparent;
      border-radius: 9px;

    }

    input[type="radio"]:checked + label {
    //  background-color: #bfb;
    //  border-color: #4c4;
    }

    input[type="radio"]:focus + label {
    //  border: 2px dashed #444;
    }

    label:hover {
      background-color: #dfd;
    }

</style>
